import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "en",
    supportedLngs: ["en", "uk"],
    fallbackLng: "en",
    ns: [
      "common",
      "auth",
      "main",
      "categories",
      "account",
      "marketplace",
      "crm",
      "adminUsers",
      "games",
      "articles",
    ],
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
      caches: ["localStorage", "cookie"],
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    react: {
      useSuspense: false,
    },
    debug: true,
    load: "currentOnly",
  });

export default i18n;
